import { render, staticRenderFns } from "./SignIns.vue?vue&type=template&id=20da58c4&"
import script from "./SignIns.vue?vue&type=script&lang=js&"
export * from "./SignIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports